var BrandArray = new Array("6|7 Series Air-Cooled", "1|9 Series Air-Cooled", "9|14 Series Water-Cooled",  "2|17 Series Air-Cooled", "3|18 Series Water-Cooled", "4|20 Series Water-Cooled", "7|24 Series Air-Cooled", "8|24 Series Water-Cooled", "5|26 Series Air-Cooled", "10|230 Series Water-Cooled");//TIG Series

var ConfigurationArray1 = new Array("1|Alumina Standard",
"2|Gas Lens",
"3|Pyrex Large Diameter",
"4|Pyrex Standard");//9 Series

var ConfigurationArray2 = new Array("1|Alumina Short",
"2|Alumina Standard",
"3|Gas Lens",
"4|Stubby Gas Lens",
"5|Pyrex Large Diameter",
"6|Pyrex Short",
"7|Pyrex Standard");//17 Series

var ConfigurationArray3 = new Array("1|Alumina Short",
"2|Alumina Standard",
"3|Gas Lens",
"4|Stubby Gas Lens",
"5|Pyrex Large Diameter",
"6|Pyrex Short",
"7|Pyrex Standard");//18 Series

var ConfigurationArray4 = new Array("1|Alumina Standard",
"2|Gas Lens",
"3|Pyrex Large Diameter",
"4|Pyrex Standard");//20 Series

var ConfigurationArray5 = new Array("1|Alumina Short",
"2|Alumina Standard",
"3|Gas Lens",
"4|Stubby Gas Lens",
"5|Pyrex Large Diameter",
"6|Pyrex Short",
"7|Pyrex Standard");//26 Series

var ConfigurationArray6 = new Array("1|Standard");//7 Series

var ConfigurationArray7 = new Array("1|Alumina Standard",
"2|Gas Lens",
"3|Micro Gas Lens");//24 air-cooled Series

var ConfigurationArray8 = new Array("1|Alumina Standard",
"2|Gas Lens",
"3|Micro Gas Lens");//24 water-cooled Series

var ConfigurationArray9 = new Array("1|Standard");//9 Series

var ConfigurationArray10 = new Array("1|Alumina Standard",
"2|Gas Lens",
"3|Pyrex Large Diameter",
"4|Pyrex Standard");//230 Series


function loadBrand()
{
	var selectBrand = document.getElementById("selectBrand");

	if (selectBrand != null && BrandArray != null)
	{
		loadOptions(selectBrand, BrandArray, "- Series -");	
	}	
}

function loadOptions(select, list, initOption)
{
	if (select != null && list != null)
	{
		select.options.length = 0;
		select.options[select.options.length] = new Option(initOption, "-1");
		for (i = 0; i < list.length; i++)
		{
			var opt = list[i].split("|");
			select.options[select.options.length] = new Option(opt[1], opt[0]);
		}
	}
}

function loadJoes(select, list, initOption)
{
	if (select != null && list != null)
	{
		select.options.length = 0;
		select.options[select.options.length] = new Option(initOption, "-1");
		for (i = 0; i < list.length; i++)
		{
			var opt = list[i];
			select.options[select.options.length] = new Option(opt, opt);
		}
	}
}

function resetSelect(select)
{
	var btnSearch = document.getElementById("btnSearch");

	select.options[0].selected = true;
	select.disabled = true;
	btnSearch.disabled = true;
}

function changeBrand()
{
	var selectBrand = document.getElementById("selectBrand");
	var selectConfiguration = document.getElementById("selectConfiguration");
	var selectJoe = document.getElementById("selectJoe");

		
	if (selectBrand != null)
	{
		if (selectBrand.value != "-1")
		{
			if (selectConfiguration != null)
			{
				loadOptions(selectConfiguration, eval("ConfigurationArray" + selectBrand.value), "- Configuration -");
				selectConfiguration.disabled = false;
				resetSelect(selectJoe);

			}		
		}
		else
		{
			resetSelect(selectConfiguration);	
			resetSelect(selectJoe);

		}
	}
}

function changeConfiguration()
{
	var selectConfiguration = document.getElementById("selectConfiguration");
	//*var selectJoe = document.getElementById("selectJoe");
	var override = false;

	if (selectConfiguration != null)
	{
		if (selectJoe != null)
		{
			if (selectConfiguration.value != "-1")
			{
				try
				{
					eval("JoeArray" + selectConfiguration.value);
					override = true;
				}
				catch(err)
				{
					override = false;
				}
			
				if (override)
				{
					loadJoes(selectJoe, eval("JoeArray" + selectConfiguration.value), "- Joe -");

				}
				else
				{
					loadJoes(selectJoe, JoeArrayDefault, "- Joe -");

				}
				selectJoe.disabled = false;
			}
			else
			{
				resetSelect(selectJoe);

			}
		}
	}
	else
	{
		resetSelect(selectJoe);
	}
}

function changeJoe()
{
	var selectJoe = document.getElementById("selectJoe");
	var btnSearch = document.getElementById("btnSearch");
	var override = false;

	if (selectJoe != null)
	{
		if (selectJoe.value != "-1")
		{

			btnSearch.disabled = false;
		}
		else
		{

			btnSearch.disabled = false;
		}
	}
}

function performSearch()
{
	var selectBrand = document.getElementById("selectBrand");
	var selectConfiguration = document.getElementById("selectConfiguration");
	//*var selectJoe = document.getElementById("selectJoe");

	
	if (selectConfiguration != null)
	{
		//*var mod = selectJoe.options[selectJoe.selectedIndex].text;
var Brand = selectBrand.options[selectBrand.selectedIndex].text.replace(' ', '_' ).split(' ').join('_');

var Configuration = selectConfiguration.options[selectConfiguration.selectedIndex].text.replace(' ', '_' ).split(' ').join('_');
      
		var url = "https://usaweld.com/collections/";
	
        url += Brand + "_" + Configuration;

		doSearch(url); 		
	}
}

function doSearch(url)
{
		top.location.href = url; 
}// JavaScript Document// JavaScript Document// JavaScript Document